export function KpiCard({ label, value, sub, badge }) {
  return (
    <div className="group relative overflow-hidden rounded-2xl bg-white/70 dark:bg-slate-900/60 backdrop-blur-xl p-5 shadow-card ring-1 ring-slate-900/5 dark:ring-white/10 border border-white/60 dark:border-white/10 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-card-hover">
      {/* Top glass sheen + soft brand corner glow */}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-16 bg-glass-sheen opacity-70 dark:opacity-0" />
      <span className="pointer-events-none absolute -right-10 -top-10 h-28 w-28 rounded-full bg-brand/10 blur-2xl transition-opacity duration-300 group-hover:opacity-100 opacity-70" />
      {/* Brand accent rail */}
      <span className="absolute left-0 top-0 h-full w-1.5 bg-brand-gradient" />

      <div className="relative">
        <div className="text-sm font-medium text-slate-500 dark:text-slate-400">{label}</div>
        <div className="mt-1.5 flex items-center gap-2">
          <div className="nums text-[26px] font-bold leading-none tracking-tight text-navy-800 dark:text-slate-100">{value}</div>
          {badge}
        </div>
        {sub && <div className="mt-1.5 text-xs text-slate-400 dark:text-slate-500">{sub}</div>}
      </div>
    </div>
  );
}
